import { axiosWithCredentials } from "../api/axios";
import { useContext, useEffect } from "react";
import AppContext from "../context/AppContext";
import refreshAccessToken from "../requireAuth/persistLogIn";

/**
 * This code is axiosPrivate, it intercepts axios
 * requests and checks for access tokens, facilitating
 * user authentication and authorization.
 */

const useAxiosPrivate = () => {
  const { auth, setAuth, setActivitySettings, logOut } = useContext(AppContext);

  useEffect(() => {
    const requestIntercept = axiosWithCredentials.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${auth?.accessToken}`;
        }
        return config;
      },
      (error) => {
        Promise.reject(error);
      },
    );

    const responseIntercept = axiosWithCredentials.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        const ignoredRoutes = ["/googleGuestAuth", "/googleAuth"];

        if (ignoredRoutes.some((route) => prevRequest?.url?.includes(route))) {
          return Promise.reject(error);
        }
        if (
          (error?.response?.status === 403 || error?.response?.status === 401) &&
          !prevRequest?.sent
        ) {
          // if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const fromRefreshAccess = await refreshAccessToken(setAuth, setActivitySettings);
          console.log("fromRefreshAccess", fromRefreshAccess);
          // console.log("fromRefreshAccess.accessToken", fromRefreshAccess.accessToken);
          // const newAccessToken = await await refreshAccessToken(setAuth)
          if (!fromRefreshAccess || !fromRefreshAccess.accessToken) {
            // Refresh failed → log user out
            logOut();
            return Promise.reject(error);
          }
          const newAccessToken = fromRefreshAccess.accessToken;

          // console.log('NEWACCESST', newAccessToken)

          if (newAccessToken === undefined) {
            logOut();
          }

          prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axiosWithCredentials(prevRequest);
        }

        // Handle invalid signature or tampered token
        if (
          error?.response?.status === 401 &&
          error?.response?.data?.action === "LOGOUT_REQUIRED"
        ) {
          // console.log("Invalid signature → forcing logout");
          logOut();
          return Promise.reject(error);
        }

        return Promise.reject(error);
      },
    );

    //removing interceptors

    return () => {
      axiosWithCredentials.interceptors.request.eject(requestIntercept);
      axiosWithCredentials.interceptors.response.eject(responseIntercept);
    };
  }, [auth]);

  return axiosWithCredentials;
};

export default useAxiosPrivate;
